const Pagination = {
  create(node, options) {
    this.node = node;
    this.options = options;

    this.hiddenPage = this.node.querySelector('.js-media-page');

    this.page = parseInt(this.hiddenPage.value, 10);

    this.createListeners();
  },

  createListeners() {
    $(this.node).on('click', '.pagination a', (e) => {
      e.preventDefault();

      const $el = $(e.currentTarget);
      const rel = $el.attr('rel');

      if (rel === 'next') {
        this.page += 1;
      } else if (rel === 'prev') {
        this.page -= 1;
      } else {
        this.page = parseInt($el.text().trim(), 10);
      }

      this.hiddenPage.value = this.page;

      $(this.hiddenPage).trigger('change');

      window.pubsub.publish('media:filter');
    });
  },
};

export default Pagination;
